goog.provide("shadow.js.shim.module$$mui$material$Button");
goog.provide("module$shadow_js_shim_module$$mui$material$Button");
shadow.js.shim.module$$mui$material$Button = shadow.js.nativeProvides["@mui/material/Button"] = shadow$bridge("@mui/material/Button");
module$shadow_js_shim_module$$mui$material$Button.default = shadow.js.shim.module$$mui$material$Button;
